<app-session-sites-header-component 
    [session]="session()"
    [toBeExportedSitesLength]="(selectedSites().length == 0 ? sites().length : selectedSites().length)"
    [selectedSitesLength]="selectedSites().length"
    [eligibilitySelectedSitesLength]="foundSelectedSites().length"
    (displayModeChange)="displayMode.set($event)"
    (openEligibilityModalClicked)="openEligibilityModal()"
    (openAccessConfigurationClicked)="openAccessConfigurationModal()"
    (importSitesManuallyClicked)="importFromManualInput()"
    (importSitesFromClientClicked)="importFromExistingClient()"
    (importSitesFromFileClicked)="importFromCSV()"
    (editSessionNameClicked)="editSessionName()"
    (duplicateSessionClicked)="duplicateSession()"
    (shareSessionClicked)="notifyUrlCopied()"
    (exportStdXlsxClicked)="exportAsStdXLSX()"
    (exportNova2CsvClicked)="exportAsNova2XLSX()"
    (exportNova2XlsxClicked)="exportAsNova2XLSX()"
    (deleteSitesClicked)="deleteSelectedSites()"
    (relaunchAddressValidation)="launchSelectedSitesFiab()"
>
</app-session-sites-header-component>

<div class="flex flex-col w-full session-sites-container">
    <app-sites-progress-bar-component [sites]="sites"></app-sites-progress-bar-component>
    <div class="h-full">
        @if (displayMode() === 'addressValidation') {
            <as-split 
                #split
                direction="horizontal"
                [useTransition]="true"
                >
                <as-split-area [size]="100 - mapSize()">
                    <div class="flex h-full">
                        <ag-grid-angular
                            class="p-2 grid-dimensions" 
                            [localeText]="gridLocale"
                            [rowData]="sites()"
                            [selectionColumnDef]="selectionColumnDef"
                            [loadingOverlayComponent]="loadingOverlayComponent"
                            [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                            [getRowId]="getRowId"
                            [rowClassRules]="rowClassRules"
                            [pagination]="false"
                            [animateRows]="false"
                            [context]="gridContext"
                            [readOnlyEdit]="true"
                            [rowSelection]="{mode: 'multiRow', selectAll: 'filtered'}"
                            (rowClicked)="selectSite($event.data)"
                            (rowDoubleClicked)="{}"
                            (cellEditRequest)="onCellEditRequest($event)"
                            (gridReady)="onGridReady($event)"
                            (selectionChanged)="onSiteSelectionChanged($event)"
                            [overlayNoRowsTemplate]="noRowsTemplate"
                        />
                    </div>
                </as-split-area>
                <as-split-area [size]="mapSize()">
                    <!-- TODO: Separate component? -->
                    <div class="map-area">
                        @if (previewedSite()) {
                            <mat-form-field class="map-input-field">
                                <mat-label>Repositionner avec coordonnées GPS</mat-label>
                                <input 
                                    matInput 
                                    type="text" 
                                    placeholder="50.00000, 1.00000"
                                    [(ngModel)]="mapSearchInput"
                                    (keydown.enter)="moveSiteToCoordinates()"
                                >
                                <button 
                                    matSuffix 
                                    matIconButton 
                                    class="ml-2"
                                    aria-label="Clear"
                                    (click)="mapSearchInput.set('')"
                                    [matTooltip]="'Effacer'">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        }
                        <app-map-component 
                            #map 
                            [selectedSiteIndex]="previewedSiteIndex()"
                            (onClickSiteMarker)="selectSiteById($event)"
                            (onMoveSiteMarker)="onMoveSiteMarker($event)"
                            (onClickFibreBuildingSiteMarker)="onClickFibreBuildingSiteMarker($event)"
                            >
                        </app-map-component>

                        @if (previewedSite()) {

                            <div class="map-bottom-panel flex flex-col items-center">
                                <div class="flex flex-row justify-between gap-4">
                                    @for (state of ADDRESS_STATES; track state.value) {
                                    <button 
                                        [class]="{'selected-icon-btn': previewedSite()?.validatedAddressState === state.value}" 
                                        matIconButton 
                                        matTooltip="Marquer ce site comme '{{ state.label }}'"
                                        (click)="onCurrentSiteAddressStateChange(state.value)">
                                        <mat-icon [class]="state.class">{{ state.icon }}</mat-icon>
                                    </button>
                                    }
                                </div>
                            </div>
                        }

                    </div>
                </as-split-area>
                <div
                    *asSplitGutter
                    [hoverClass]="'clickable'"
                    (click)="toggleMap()"
                    [style.left.%]="100 - mapSize()"
                >
                    <mat-icon>{{ mapSize() <= 0 ? 'chevron_left' : 'chevron_right' }}</mat-icon>
                </div>
            </as-split>
        } @else {
            <div class="flex h-full">
                <ag-grid-angular
                    class="p-2 grid-dimensions" 
                    [localeText]="gridLocale"
                    [rowData]="sites()"
                    [selectionColumnDef]="selectionColumnDef"
                    [loadingOverlayComponent]="loadingOverlayComponent"
                    [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                    [getRowId]="getRowId"
                    [rowClassRules]="eligibilityRowClassRules"
                    [pagination]="false"
                    [animateRows]="false"
                    [context]="gridContext"
                    [readOnlyEdit]="true"
                    [rowSelection]="eligibilityRowSelection"
                    (gridReady)="onGridReady($event)"
                    (selectionChanged)="onSiteSelectionChanged($event)"
                    [overlayNoRowsTemplate]="noRowsTemplate"
                />
            </div>
        }
    </div>

    
    <!-- Invisible grid to make nova2 exports easier -->
    <ag-grid-angular
        style="display: none"
        [columnDefs]="nova2columns"
        [rowData]="sites()"
        (gridReady)="onNova2GridReady($event)"
        />
</div>



